{
  "payTypes": {
    "monthly": "Lương tháng",
    "daily": "Lương ngày"
  },
  "status": {
    "active": "Đang áp dụng",
    "expired": "Hết hiệu lực"
  },
  "periodStatus": {
    "draft": "Nháp",
    "calculated": "Đã tính",
    "approved": "Đã duyệt",
    "locked": "Đã khóa",
    "cancelled": "Đã hủy"
  },
  "entryStatus": {
    "provisional": "Tạm tính",
    "confirmed": "Nhân viên xác nhận",
    "paid": "Đã chi tiền",
    "needsRecalc": "Cần tính lại"
  },
    "lineKinds": {
      "basePay": "Lương cơ bản",
      "component": "Khoản lương",
      "manual": "Dòng tay",
      "adjustment": "Điều chỉnh",
      "commissionPay": "Hoa hồng",
      "referralCommissionPay": "Hoa hồng giới thiệu",
      "kpiPay": "Thưởng KPI",
      "overtimePay": "Tăng ca",
      "attendanceBonus": "Chuyên cần",
      "lateDeduct": "Khấu trừ đi trễ",
      "advanceDeduct": "Tạm ứng"
    },
  "tab": {
    "currentTitle": "Cấu hình hiện tại",
    "historyTitle": "Lịch sử hiệu lực",
    "empty": "Chưa có cấu hình lương.",
    "emptyHistory": "Chưa có phiên bản trước."
  },
  "pages": {
    "listTitle": "Lương",
    "detailPageTitle": "Chi tiết kỳ lương",
    "detailTitle": "Kỳ lương {{periodKey}}",
    "entryPageTitle": "Phiếu lương",
    "entryDetailTitle": "Chi tiết phiếu lương",
    "entryNotFound": "Không tìm thấy phiếu lương.",
    "permissionDenied": "Bạn không có quyền xem bảng lương.",
    "empty": "Chưa có kỳ lương.",
    "emptyAssignments": "Chưa có nhân viên nào có công thức lương.",
    "emptyEntries": "Chưa có dòng nhân viên. Nhấn Tính lương để tạo.",
    "tabs": {
      "periods": "Kỳ lương",
      "formulas": "Công thức lương",
      "components": "Khoản lương",
      "mine": "Phiếu của tôi",
      "advances": "Tạm ứng"
    },
    "tabsAria": "Phần module lương",
    "mineEmpty": "Chưa có phiếu lương. Tài khoản phải gắn hồ sơ nhân viên.",
    "staffPayslipsEmpty": "Chưa có phiếu lương.",
    "minePermissionDenied": "Bạn không có quyền xem phiếu lương của mình."
  },
  "mine": {
    "unpaid": "Chưa chi"
  },
  "table": {
    "period": "Kỳ",
    "clinic": "Phòng khám",
    "dates": "Khoảng ngày",
    "status": "Trạng thái",
    "staffCount": "Số NV",
    "netTotal": "Thực lĩnh",
    "payslipCode": "Mã phiếu",
    "staff": "Nhân viên",
    "payType": "Loại lương",
    "baseSalary": "Lương cơ bản",
    "scheduledDays": "Ngày công chuẩn",
    "actualWorkedDays": "Ngày làm việc thực tế",
    "unpaidLeaveDays": "Ngày nghỉ không lương",
    "payableDays": "Ngày công",
    "gross": "Tổng thu",
    "deductionTotal": "Tổng khấu trừ",
    "net": "Thực nhận",
    "lineKind": "Loại",
    "index": "STT",
    "amount": "Số tiền",
    "warnings": "Cảnh báo",
    "paid": "Đã chi",
    "createdAt": "Ngày tạo",
    "createdBy": "Người tạo",
    "updatedAt": "Ngày chỉnh sửa",
    "editedBy": "Người chỉnh sửa",
    "formula": "Công thức lương",
    "componentName": "Tên khoản",
    "direction": "Loại",
    "amountType": "Cách tính",
    "amountApplied": "Số tiền áp dụng"
  },
  "fields": {
    "payType": "Loại lương",
    "components": "Khoản lương",
    "copyFromStaff": "Sao chép từ nhân viên",
    "baseSalary": "Mức lương",
    "effectiveFrom": "Hiệu lực từ",
    "effectiveTo": "Hiệu lực đến",
    "status": "Trạng thái",
    "openEnded": "Hiện tại",
    "clinic": "Phòng khám",
    "periodKey": "Tháng lương",
    "dateRange": "Khoảng ngày",
    "payableDays": "Ngày công (lương ngày)",
    "adjustmentAmount": "Số tiền điều chỉnh",
    "adjustmentReason": "Lý do",
    "adjustmentLabel": "Nội dung",
    "unlockReason": "Lý do mở khóa",
    "scheduledDays": "Ngày công chuẩn",
    "actualWorkedDays": "Ngày làm việc thực tế",
    "unpaidLeaveDays": "Ngày nghỉ không lương",
    "presentDays": "Ngày có mặt",
    "lateMinutes": "Đi muộn (phút)",
    "earlyLeaveMinutes": "Về sớm (phút)",
    "overtimeMinutes": "Tăng ca (phút)",
    "overtimePay": "Tiền tăng ca",
    "attendanceBonus": "Chuyên cần",
    "attendanceBonusEligible": "Đạt chuyên cần",
    "attendanceBonusFailReasons": "Lý do không đạt",
    "lateDeduct": "Khấu trừ đi trễ",
    "approvedLeaveDays": "Ngày nghỉ đã duyệt",
    "snapshotHint": "Khóa bảng công tháng rồi Tính: lương tháng prorate theo ngày ca; nghỉ không lương giảm công; OT/đi trễ/chuyên cần ra tiền nếu công thức gắn khoản tương ứng. Gộp hoa hồng: gắn khoản Hoa hồng.",
    "attendanceMonthLocked": "Bảng công tháng đã khóa. Lương ngày lấy ngày công đã chốt — không nhập tay.",
    "commissionAmount": "Hoa hồng đã gộp",
    "commissionEntries": "Số dòng hoa hồng",
    "commissionSourceLink": "Mở kỳ hoa hồng",
    "referralCommissionAmount": "Hoa hồng giới thiệu đã gộp",
    "referralCommissionEntries": "Số dòng hoa hồng giới thiệu",
    "referralCommissionSourceLink": "Mở hoa hồng giới thiệu",
    "kpiAmount": "Thưởng KPI đã gộp",
    "kpiAssignments": "Số dòng thưởng KPI",
    "kpiSourceLink": "Mở kỳ KPI",
    "advanceAmount": "Tạm ứng đã trừ",
    "advanceDeductedInPeriod": "Số trừ trong kỳ",
    "advanceNoneInPeriod": "Kỳ này không trừ tạm ứng.",
    "paymentMethod": "Phương thức chi",
    "expenseDate": "Ngày chi",
    "notes": "Ghi chú"
  },
  "kpiLines": {
    "empty": "Kỳ này không có thưởng KPI.",
    "metric": "Chỉ tiêu",
    "actual": "Thực đạt",
    "target": "Mục tiêu",
    "basis": "Cách ra tiền",
    "amount": "Thành tiền",
    "total": "Tổng",
    "perUnit": "{{amount}}/đơn vị",
    "percentBand": "Đạt từ {{percent}}%",
    "quantityTier": "Từ {{count}}",
    "modes": {
      "perUnit": "Theo số làm được",
      "percentBands": "Theo % hoàn thành",
      "quantityTiers": "Theo bậc số lượng"
    }
  },
  "commissionLines": {
    "empty": "Kỳ này không có hoa hồng."
  },
  "attendanceBonusSource": {
    "subtitlePass": "Đạt · {{amount}}",
    "subtitleFail": "Không đạt · {{amount}}",
    "condition": "Điều kiện",
    "actual": "Thực tế",
    "dates": "Ngày",
    "limit": "Ngưỡng",
    "result": "Kết quả",
    "pass": "Đạt",
    "fail": "Không đạt",
    "lateDays": "Ngày đi trễ",
    "earlyLeaveDays": "Ngày về sớm",
    "leaveDays": "Ngày nghỉ đã duyệt",
    "limitMax": "Tối đa {{count}}",
    "days": "{{count}} ngày"
  },
  "referralLines": {
    "empty": "Kỳ này không có hoa hồng giới thiệu.",
    "subtitle": "{{count}} dòng · {{total}}",
    "patient": "Bệnh nhân",
    "referrer": "Người giới thiệu",
    "source": "Nguồn",
    "sourceChart": "Hồ sơ bệnh nhân",
    "sourcePayment": "Phiếu thu {{code}}",
    "sourceService": "{{name}} · {{code}}",
    "formula": "Cách tính",
    "basis": "Cơ sở",
    "chartCount": "{{count}} hồ sơ",
    "formulaPercent": "{{value}}% {{basis}}",
    "formulaFixedChart": "{{amount}} / hồ sơ",
    "formulaFixed": "{{amount}}"
  },
  "placeholders": {
    "clinic": "Chọn phòng khám",
    "name": "Ví dụ: Phụ cấp ăn trưa",
    "code": "Ví dụ: PHU_CAP",
    "amount": "Ví dụ: 500000",
    "percent": "Ví dụ: 10",
    "staff": "Chọn nhân viên",
    "payType": "Chọn loại lương",
    "effectiveFrom": "Chọn ngày hiệu lực",
    "components": "Chọn khoản lương",
    "copyFromStaff": "Chọn nhân viên để sao chép",
    "searchAssignments": "Tìm nhân viên, khoản lương",
    "notes": "Nhập ghi chú",
    "extraComponents": "Chọn khoản thêm",
    "unlockReason": "Nhập lý do mở khóa",
    "adjustmentAmount": "Ví dụ: -500000",
    "adjustmentLabel": "Ví dụ: Điều chỉnh",
    "adjustmentReason": "Nhập lý do điều chỉnh"
  },
  "sections": {
    "summary": "Tóm tắt",
    "attendance": "Công",
    "sources": "Khoản đã gộp",
    "lines": "Chi tiết phiếu"
  },
  "actions": {
    "addVersion": "Thêm phiên bản",
    "editVersion": "Sửa phiên bản",
    "save": "Lưu",
    "cancel": "Hủy",
    "openPeriod": "Mở kỳ lương",
    "openingPeriod": "Đang mở...",
    "changeStatus": "Đổi trạng thái",
    "calculate": "Tính lương",
    "calculating": "Đang tính...",
    "recalculate": "Tính lại",
    "recalculating": "Đang tính lại...",
    "approve": "Duyệt",
    "approving": "Đang duyệt...",
    "reject": "Từ chối",
    "rejecting": "Đang từ chối...",
    "lock": "Khóa kỳ",
    "locking": "Đang khóa...",
    "unlock": "Mở khóa",
    "unlocking": "Đang mở khóa...",
    "cancelPeriod": "Hủy kỳ",
    "cancellingPeriod": "Đang hủy...",
    "exporting": "Đang xuất...",
    "extras": "Phát sinh",
    "adjust": "Thêm điều chỉnh",
    "adjusting": "Đang thêm điều chỉnh...",
    "close": "Đóng",
    "confirm": "Xác nhận",
    "confirming": "Đang xác nhận...",
    "dispute": "Không đồng ý",
    "disputing": "Đang nhả khóa...",
    "pay": "Chi lương",
    "selectAllUnpaid": "Chọn tất cả chưa chi",
    "openExpense": "Mở phiếu chi",
    "export": "Xuất bảng",
    "history": "Lịch sử",
    "viewPeriod": "Xem kỳ",
    "viewDetail": "Xem chi tiết",
    "edit": "Sửa"
  },
  "history": {
    "periodTitle": "Lịch sử kỳ lương",
    "periodEmpty": "Chưa có lịch sử cho kỳ lương này.",
    "componentTitle": "Lịch sử khoản lương",
    "componentEmpty": "Chưa có lịch sử cho khoản lương này.",
    "advanceTitle": "Lịch sử tạm ứng",
    "advanceEmpty": "Chưa có lịch sử cho tạm ứng này.",
    "compensationTitle": "Lịch sử công thức lương",
    "compensationEmpty": "Chưa có lịch sử cho công thức lương này."
  },
  "entryMenu": {
    "print": "In phiếu",
    "export": "Xuất phiếu",
    "recalculate": "Tính lại phiếu"
  },
  "lineEdit": {
    "titleManual": "Sửa khoản phát sinh",
    "titleAdjustment": "Sửa điều chỉnh",
    "titleComponent": "Sửa khoản lương",
    "componentHint": "Số tiền trên phiếu kỳ này. Không đổi công thức lương."
  },
  "extras": {
    "title": "Phát sinh",
    "empty": "Chưa có khoản phát sinh ngoài công thức.",
    "recalcBanner": "Khoản phát sinh đã đổi. Nhấn Tính lại để áp vào phiếu.",
    "actions": {
      "add": "Thêm phát sinh"
    },
    "fields": {
      "label": "Nội dung",
      "amount": "Số tiền",
      "amountHint": "Số dương là thưởng, số âm là phạt."
    },
    "dialog": {
      "add": "Thêm khoản phát sinh",
      "edit": "Sửa khoản phát sinh"
    },
    "validation": {
      "staff": "Chọn nhân viên",
      "label": "Nhập nội dung",
      "amount": "Số tiền phải khác 0"
    },
    "toasts": {
      "created": "Đã thêm khoản phát sinh",
      "updated": "Đã lưu khoản phát sinh",
      "deleted": "Đã xóa khoản phát sinh"
    }
  },
  "advances": {
    "empty": "Chưa có tạm ứng.",
    "emptyMine": "Chưa có đơn xin tạm ứng.",
    "emptyParty": "Chưa gán",
    "noStaffProfile": "Tài khoản chưa gắn hồ sơ nhân viên.",
    "filters": {
      "all": "Tất cả",
      "allStatuses": "Tất cả trạng thái"
    },
    "actions": {
      "create": "Tạo tạm ứng",
      "creating": "Đang tạo...",
      "request": "Xin tạm ứng",
      "approve": "Duyệt",
      "reject": "Từ chối",
      "cancel": "Hủy đơn",
      "pay": "Chi"
    },
    "fields": {
      "amount": "Số tiền",
      "notes": "Ghi chú",
      "followers": "Người theo dõi",
      "followersPlaceholder": "Thêm người theo dõi",
      "approvers": "Người duyệt",
      "rejectReason": "Lý do từ chối"
    },
    "table": {
      "amount": "Số tiền",
      "original": "Đã chi",
      "remaining": "Còn trừ",
      "expense": "Phiếu chi"
    },
    "status": {
      "pending": "Chờ duyệt",
      "approved": "Đã duyệt",
      "rejected": "Từ chối",
      "cancelled": "Đã hủy",
      "open": "Còn số dư",
      "settled": "Đã trừ hết"
    },
    "dialog": {
      "create": "Tạo tạm ứng lương",
      "request": "Xin tạm ứng",
      "detail": "Đơn tạm ứng",
      "pay": "Chi tạm ứng"
    },
    "validation": {
      "staff": "Chọn nhân viên",
      "amount": "Số tiền phải lớn hơn 0",
      "expenseDate": "Chọn ngày chi"
    },
    "toasts": {
      "created": "Đã tạo tạm ứng",
      "createFailed": "Không tạo được tạm ứng",
      "requested": "Đã gửi đơn xin tạm ứng",
      "requestFailed": "Không gửi được đơn xin tạm ứng",
      "approved": "Đã duyệt đơn tạm ứng",
      "approveFailed": "Không duyệt được đơn",
      "rejected": "Đã từ chối đơn tạm ứng",
      "rejectFailed": "Không từ chối được đơn",
      "cancelled": "Đã hủy đơn tạm ứng",
      "cancelFailed": "Không hủy được đơn",
      "paid": "Đã chi tạm ứng",
      "payFailed": "Không chi được tạm ứng"
    }
  },
  "dialog": {
    "title": "Thêm phiên bản công thức lương",
    "editTitle": "Sửa công thức lương",
    "hint": "Tick các khoản áp cho nhân viên. Mức lương nhập trên hàng Lương cơ bản khi chọn. Phiên bản đang áp dụng sẽ hết hiệu lực vào ngày liền trước ngày này.",
    "openTitle": "Mở kỳ lương",
    "unlockTitle": "Mở khóa kỳ lương",
    "unlockHint": "Chỉ mở khóa khi chưa chi. Kỳ sẽ trở về trạng thái đã tính.",
    "cancelTitle": "Hủy kỳ lương nháp?",
    "cancelHint": "Kỳ nháp sẽ chuyển sang đã hủy, không xóa dữ liệu.",
    "adjustTitle": "Điều chỉnh dòng lương",
    "payTitle": "Chi lương",
    "payHint": "Tạo một phiếu chi Lương & phụ cấp cho mỗi nhân viên đã chọn. Số tiền = thực lĩnh. Không chi trùng.",
    "payEmpty": "Không còn nhân viên chưa chi với thực lĩnh lớn hơn 0.",
    "paySummary": "{{count}} nhân viên · {{amount}}"
  },
  "validation": {
    "staff": "Chọn nhân viên",
    "payType": "Chọn loại lương",
    "components": "Chọn ít nhất một khoản lương",
    "baseSalary": "Nhập mức lương lớn hơn hoặc bằng 0",
    "effectiveFrom": "Chọn ngày hiệu lực",
    "clinic": "Chọn phòng khám",
    "periodKey": "Chọn tháng lương",
    "unlockReason": "Nhập lý do mở khóa",
    "adjustmentAmount": "Nhập số tiền khác 0",
    "adjustmentReason": "Nhập lý do điều chỉnh"
  },
  "toasts": {
    "loadFailed": "Không tải được cấu hình lương",
    "created": "Đã lưu công thức lương",
    "updated": "Đã cập nhật công thức lương",
    "createFailed": "Không lưu được công thức lương",
    "updateFailed": "Không cập nhật được công thức lương",
    "copySourceEmpty": "Nhân viên nguồn chưa có công thức lương",
    "copyFailed": "Không sao chép được công thức lương",
    "periodCreated": "Đã mở kỳ lương",
    "periodCreateFailed": "Không mở được kỳ lương",
    "periodUpdated": "Đã lưu kỳ lương",
    "periodLoadFailed": "Không tải được kỳ lương",
    "entryLoadFailed": "Không tải được chi tiết khoản lương",
    "calculated": "Đã tính lương",
    "entryRecalculated": "Đã tính lại phiếu lương",
    "calculateFailed": "Không tính được lương",
    "approved": "Đã duyệt kỳ lương",
    "rejected": "Đã trả kỳ về đã tính",
    "locked": "Đã khóa kỳ lương",
    "unlocked": "Đã mở khóa kỳ lương",
    "cancelled": "Đã hủy kỳ lương",
    "adjusted": "Đã thêm điều chỉnh",
    "lineUpdated": "Đã lưu dòng phiếu lương",
    "confirmed": "Đã xác nhận phiếu lương",
    "disputed": "Đã nhả khóa nguồn, phiếu vẫn tạm tính",
    "actionFailed": "Không thực hiện được thao tác",
    "paid": "Đã chi lương cho {{count}} nhân viên",
    "payFailed": "Không chi được lương",
    "exported": "Đã tải bảng lương",
    "exportFailed": "Không xuất được bảng lương"
  },
  "print": {
    "print": "In phiếu lương",
    "download": "Tải phiếu lương",
    "printFailed": "In phiếu lương thất bại",
    "downloadFailed": "Tải phiếu lương thất bại",
    "downloadSuccess": "Đã tải phiếu lương"
  },
  "warnings": {
    "DAILY_PAYABLE_DAYS_REQUIRED": "Thiếu ngày công (lương ngày)",
    "MONTHLY_SCHEDULED_DAYS_REQUIRED": "Thiếu công chuẩn từ lịch làm việc (lương tháng)",
    "SKIPPED_NO_COMPENSATION": "Bỏ qua vì chưa có công thức lương",
    "skippedNoCompensationSummary": "Đã bỏ qua ({{count}}) nhân viên vì chưa có công thức lương.",
    "viewDetails": "Xem chi tiết",
    "skippedDialogTitle": "Danh sách nhân viên chưa cấu hình lương",
    "configureSalary": "Cấu hình lương",
    "index": "STT",
    "fullName": "Họ tên",
    "department": "Bộ phận"
  },
  "errors": {
    "INVALID_PERIOD_KEY": "Tháng lương không hợp lệ",
    "INVALID_DATE_RANGE": "Khoảng ngày không hợp lệ",
    "PERIOD_OVERLAP": "Đã có kỳ lương mở trùng phòng và ngày",
    "PERIOD_NOT_DRAFT": "Chỉ thao tác được khi kỳ còn nháp",
    "PERIOD_NOT_CALCULATED": "Kỳ phải ở trạng thái đã tính",
    "PERIOD_NOT_APPROVED": "Kỳ phải ở trạng thái đã duyệt",
    "PERIOD_LOCKED": "Kỳ đã khóa, không sửa được",
    "PERIOD_HAS_CONFIRMED_ENTRIES": "Không hủy kỳ đã có phiếu xác nhận hoặc đã chi",
    "PERIOD_NOTHING_TO_CALCULATE": "Không còn phiếu tạm tính để tính lại",
    "PERIOD_HAS_PAYMENTS": "Không mở khóa kỳ đã chi lương",
    "ENTRY_NOT_CONFIRMED": "Chỉ chi phiếu nhân viên đã xác nhận",
    "ENTRY_FROZEN": "Phiếu đã xác nhận hoặc đã chi không đổi được",
    "ENTRY_NEEDS_RECALC": "Phiếu cần tính lại trước khi xác nhận",
    "ENTRY_NOT_PROVISIONAL": "Chỉ thao tác được trên phiếu tạm tính",
    "ENTRY_ALREADY_PAID": "Phiếu đã chi",
    "ATTENDANCE_IN_PAYROLL": "Không sửa công khi phiếu lương của nhân viên đang tạm tính hoặc đã xác nhận",
    "UNLOCK_REASON_REQUIRED": "Cần lý do khi mở khóa",
    "STAFF_PERIOD_OVERLAP": "Nhân viên đã thuộc kỳ lương mở khác trong khoảng ngày này",
    "ENTRY_NOT_ADJUSTABLE": "Chỉ điều chỉnh phiếu tạm tính",
    "LINE_NOT_EDITABLE": "Không sửa được khoản này",
    "INVALID_ADJUSTMENT": "Điều chỉnh không hợp lệ",
    "COMMISSION_ALREADY_PAID": "Hoa hồng vừa được chi hoặc đã gộp vào kỳ khác. Tính lại kỳ lương.",
    "COMMISSION_ALREADY_CONSUMED": "Hoa hồng đã gộp vào bảng lương, không chi hoặc mở khóa riêng được.",
    "PERIOD_NOT_LOCKED": "Kỳ phải đã khóa mới chi lương được",
    "PAYROLL_INVALID_NET": "Thực lĩnh phải lớn hơn 0 mới chi được",
    "PAYROLL_NOTHING_TO_PAY": "Không có nhân viên hợp lệ để chi",
    "COMMISSION_MUTEX_VIOLATED": "Hoa hồng trên phiếu lương không còn khớp dòng đã gộp. Không chi được.",
    "REFERRAL_COMMISSION_ALREADY_PAID": "Hoa hồng giới thiệu vừa được chi hoặc đã gộp vào kỳ khác. Tính lại kỳ lương.",
    "REFERRAL_COMMISSION_ALREADY_CONSUMED": "Hoa hồng giới thiệu đã gộp vào bảng lương, không chi hoặc mở khóa riêng được.",
    "REFERRAL_COMMISSION_MUTEX_VIOLATED": "Hoa hồng giới thiệu trên phiếu lương không còn khớp dòng đã gộp. Không chi được.",
    "PERIOD_NOT_READY": "Kỳ phải đã tính, đã duyệt hoặc đã khóa mới xuất / in được",
    "COMPONENT_CODE_EXISTS": "Mã khoản lương đã tồn tại",
    "INVALID_COMPONENT_PERCENT": "Phần trăm phải từ 0 đến 100",
    "COMPONENT_IN_USE": "Khoản đang nằm trong công thức lương đang áp dụng, không tắt được",
    "COMPONENT_SYSTEM": "Không tắt khoản hệ thống",
    "COMPONENTS_REQUIRED": "Cần chọn ít nhất một khoản lương",
    "COMPONENT_NOT_FOUND": "Không tìm thấy khoản lương",
    "INVALID_STAFF_INPUTS": "Khoản phát sinh không hợp lệ",
    "EXTRA_NOT_FOUND": "Không tìm thấy khoản phát sinh",
    "ADVANCE_NOT_FOUND": "Không tìm thấy tạm ứng",
    "INVALID_ADVANCE": "Tạm ứng không hợp lệ",
    "ADVANCE_ALREADY_CONSUMED": "Số dư tạm ứng vừa được trừ ở kỳ khác. Tính lại kỳ lương.",
    "PAYROLL_APPROVER_REQUIRED": "Chưa gán người duyệt tạm ứng. Liên hệ quản lý.",
    "NOT_PAYROLL_APPROVER": "Bạn không phải người duyệt đơn này.",
    "ADVANCE_NOT_PENDING": "Chỉ thao tác được khi đơn còn chờ duyệt.",
    "ADVANCE_NOT_APPROVED": "Chỉ chi được đơn đã duyệt.",
    "CANNOT_DECIDE_OWN_ADVANCE": "Không thể duyệt hoặc từ chối đơn của chính mình.",
    "COMPENSATION_PROFILE_IN_USE": "Công thức đã gắn phiếu lương, không sửa được. Thêm phiên bản mới.",
    "COMPENSATION_RANGE_OVERLAP": "Khoảng hiệu lực trùng phiên bản khác",
    "COMPENSATION_NOT_FOUND": "Không tìm thấy công thức lương",
    "EFFECTIVE_FROM_MUST_FOLLOW": "Ngày hiệu lực phải sau phiên bản đang áp dụng"
  },
  "policy": {
    "pages": {
      "title": "Khoản lương"
    },
    "tabs": {
      "components": "Khoản lương"
    },
    "search": {
      "placeholder": "Tìm theo tên hoặc mã"
    },
    "actions": {
      "addComponent": "Thêm khoản"
    },
    "kind": {
      "system": "Hệ thống",
      "custom": "Tùy chỉnh"
    },
    "status": {
      "active": "Đang dùng",
      "inactive": "Ngưng"
    },
    "directions": {
      "earning": "Khoản thu",
      "deduction": "Khoản trừ"
    },
    "amountTypes": {
      "fixed": "Số tiền cố định",
      "percentOfBase": "% lương cơ bản",
      "fromCommission": "Từ hoa hồng đã khóa",
      "fromReferralCommission": "Từ hoa hồng giới thiệu đã chốt",
      "fromKpi": "Từ thưởng KPI đã chốt",
      "fromOvertime": "Từ phút tăng ca đã khóa",
      "fromLateMinutes": "Từ phút đi trễ đã khóa",
      "fromAttendanceBonus": "Thưởng chuyên cần khi đạt điều kiện"
    },
    "fields": {
      "name": "Tên",
      "code": "Mã",
      "direction": "Loại",
      "amountType": "Cách tính",
      "amount": "Số tiền",
      "percent": "Phần trăm",
      "type": "Nguồn",
      "lineCount": "Số khoản",
      "extraComponents": "Khoản thêm",
      "fromAssignment": "Theo mức trên công thức",
      "fromCommission": "Từ hoa hồng đã khóa",
      "fromReferralCommission": "Từ hoa hồng giới thiệu đã chốt",
      "fromKpi": "Từ thưởng KPI đã chốt",
      "fromOvertime": "Từ phút tăng ca đã khóa",
      "fromLateMinutes": "Từ phút đi trễ đã khóa",
      "fromAttendanceBonus": "Khi đạt điều kiện chuyên cần",
      "baseAlwaysIncluded": "Công thức mặc định tháng gồm Lương cơ bản và Thưởng KPI. Gắn Tăng ca / Đi trễ / Hoa hồng / Chuyên cần trên công thức nếu muốn các khoản đó ra tiền (cần khóa bảng công tháng).",
      "attendanceBonusPolicy": "Điều kiện đạt chuyên cần",
      "attendanceBonusLimitPlaceholder": "Không giới hạn",
      "maxLateDays": "Tối đa số ngày đi trễ",
      "maxEarlyLeaveDays": "Tối đa số ngày về sớm",
      "maxLeaveDays": "Tối đa số ngày nghỉ (đã duyệt)"
    },
    "attendanceBonusFailReasons": {
      "LATE": "Vượt số ngày đi trễ",
      "EARLY_LEAVE": "Vượt số ngày về sớm",
      "LEAVE": "Vượt số ngày nghỉ",
      "FULL_PAYABLE_DAYS": "Thiếu công so lịch",
      "UNPAID_LEAVE": "Có nghỉ không lương"
    },
    "table": {
      "noFound": "Không có kết quả.",
      "emptyComponents": "Chưa có khoản lương."
    },
    "dialogs": {
      "addComponent": "Thêm khoản lương",
      "editComponent": "Sửa khoản lương"
    },
    "validation": {
      "name": "Nhập tên",
      "code": "Mã bắt đầu bằng chữ, chỉ gồm chữ, số và dấu _",
      "amount": "Nhập số tiền lớn hơn hoặc bằng 0",
      "percent": "Phần trăm từ 0 đến 100"
    },
    "toasts": {
      "componentCreated": "Đã tạo khoản lương",
      "componentUpdated": "Đã lưu khoản lương",
      "saveFailed": "Không lưu được"
    }
  }
}
